import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base/styles/variables';

export const SitemapItem = styled.li`
  line-height: 2.25;
`;

export const SitemapLink = styled(Link)`
  color: ${colors.lightBlue3};
`;
